import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { store } from "./store";
import { clearFilter } from "./store/constant";

const AppWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    store.dispatch(clearFilter());
  }, [location.pathname]);

  return children;
};

export default AppWrapper;
